import { FacilityDropdownComponent } from 'src/app/shared/components/dropdowns/facility-dropdown/facility-dropdown.component';
import {CarType} from './../../../../core/models/transport-operation/car-type';
import {LaasOption} from 'src/app/core/models/laas-option';
import {ChangeDetectorRef, Component, Injector, NgZone, OnInit, ViewChild} from '@angular/core';
import {FormBuilder, FormGroup} from '@angular/forms';
import {DropdownOptionsService} from 'src/app/core/services/dropdown-options.service';
import {deepCopy, genTableTranslation, isNullOrEmpty} from 'src/app/core/utils/common-functions';
import {SessionBaseComponent} from 'src/app/shared/components/session.base.component';
import {ContainerService} from '../../services/container-service.service';
import {UserPreferenceConstants} from 'src/app/core/constants/user-preference-constants.constant';
import {DecimalPipe} from '@angular/common';
import {PermissionConstants} from 'src/app/core/constants/permission-constants.constant';
import {TranslateService} from '@ngx-translate/core';
import {ContainerHeaderMove} from 'src/app/core/models/transport-operation/container-header-move';
import {CalendarComponent} from 'src/app/shared/components/calendar/calendar.component';
import {Checkbox} from 'primeng/checkbox';
import {HttpErrorResponse} from '@angular/common/http';
import {ShippingDocumentService} from 'src/app/core/services/shipping-document.service';
import {DataTableComponent} from '../../../../shared/components/data-table/data-table.component';
import {SortOrder} from '../../../../core/interface/sort-order';
import {PageInfo} from '../../../../core/models/page-info';
import { DataTableSavedBean } from 'src/app/shared/components/data-table/bean/data-table-saved-bean';
import { finalize, firstValueFrom } from 'rxjs';
import { LogisticsCustomerService } from 'src/app/core/services/logistics/customer/logistics-customer.service';

@Component({
  selector: 'laas-container-management',
  templateUrl: './container-management.component.html',
  styleUrls: ['./container-management.component.scss'],
})

export class ContainerManagementComponent
  extends SessionBaseComponent
  implements OnInit {

  readonly preferenceKey: string;
  readonly viewPermissionCode = PermissionConstants.Contianer;
  readonly unlockContainerpermissionCode = PermissionConstants.BtnContianerUnLock;
  readonly lockContainerpermissionCode = PermissionConstants.BtnContianerLock;
  readonly editPermissionCode = PermissionConstants.EditContainer;
  readonly viewContainerPackingComboBtnPermissionCode = PermissionConstants.ViewContainerPackingComboBtn;
  readonly viewDownloadContainerSignReceiptBtnPermissionCode = PermissionConstants.ViewDownloadContainerSignReceiptBtn;
  readonly viewSendContainerBoxDetailExcelBtnPermissionCode = PermissionConstants.ViewSendContainerBoxDetailExcelBtn;
  readonly ViewDownloadUnBondedDocBtnPermissionCode = PermissionConstants.ViewDownloadUnBondedDocBtn;
  readonly viewReturnTradeVanBtnPermissionCode = PermissionConstants.ViewReturnTradeVanBtn;
  @ViewChild('AssignDate') assignDate!: CalendarComponent;
  @ViewChild('headerCheckBox') headerCheckBox!: Checkbox;
  isSearchFormOpen: boolean;
  facilityOptions: any[];
  doStatusOptions: any[];
  containerTypeOptions: any[];
  selectedRows: any[] = [];
  isLockOptions: any[];
  generateCrossBoundryNoOptions: any[];
  searchForm!: FormGroup;
  containerResults: any[];
  carTypeOptions: any[]= [];
  forwarderOptions: any[] = [];
  customerOptions: any[] = [];
  containerLoading: boolean;
  showMoveContainerDialog: boolean;
  showOneMoveContainerDialog: boolean;


  showOrphanDialog = false;
  haveUnLock = false;
  haveFacilityPermission = true;
  MultipleAddress = false;
  changeContainerWarn = false;
  unLockContainerNo: number[] = [];
  showCreateContainerDialog = false;
  @ViewChild('dataTable') table!: DataTableComponent;
  sortOrder: SortOrder = {
    property: 'seqNo',
    direction: -1
  };

  selectedCols: any[];
  columns: any[];
  detailColumns: any[];

  // pick List
  targetContainer: any;
  targetOneContainer: any;
  sourceContainer: any;
  transLabel: any = '';
  targetContainerOriginal: any;
  sourceContainerOriginal: any;

  // translate label
  transContainerNumber: any;
  transTotalCarton: any;
  transTotalWeight: any;
  transTotalValue: any;

  // container move
  orphanContainer: ContainerHeaderMove;
  normalContainer: ContainerHeaderMove;
  // Status for enabling a user to edit the data on the table
  isInEditMode: boolean = false;
  pageInfo: PageInfo = {
    pageSize: 5,
    pageIndex: 0,
    totalRecords: 0,
    totalPages: 0,
  };
  currentLang: string = this.laasSetting.language;

  isLoading = false;

  constructor(
    injector: Injector,
    private dropdownOptionsService: DropdownOptionsService,
    private containerService: ContainerService,
    private logisticsCustomerService: LogisticsCustomerService,
    private decimalPipe: DecimalPipe,
    private fb: FormBuilder,
    private translate: TranslateService,
    private shippingDocumentService: ShippingDocumentService,
    private cdr: ChangeDetectorRef,
    private zone: NgZone
  ) {
    super(injector);
    this.preferenceKey = UserPreferenceConstants.ContainerManagement;
    this.isSearchFormOpen = true;
    this.facilityOptions = [];
    this.doStatusOptions = [];
    this.containerResults = [];
    this.containerLoading = false;
    this.showMoveContainerDialog = false;
    this.showOneMoveContainerDialog = false;

    this.columns = [
      { field: 'isLock', header: 'ContainerManagement.MainTable.LockStatus', dataType: 'boolean', sort: true },
      { field: 'containerCode', header: 'ContainerManagement.MainTable.ContainerNumber', sort: true },
      { field: 'containerType', header: 'ContainerManagement.MainTable.Period', sort: true },
      { field: 'facility', header: 'ContainerManagement.MainTable.Facility', sort: true },
      { field: 'forwarder', header: 'ContainerManagement.MainTable.Forwarder', sort: true },
      { field: 'updateDt', header: 'ContainerManagement.MainTable.AssignDate', dataType: 'date', sort: true },
      { field: 'pickUpLocation', header: 'ContainerManagement.MainTable.PickUp', sort: true },
      { field: 'consigneeKey', header: 'ContainerManagement.MainTable.Customer', sort: true },
      { field: 'count', header: 'ContainerManagement.MainTable.DOQty', dataType: 'number', sort: true },
      { field: 'grossWeight', header: 'ContainerManagement.MainTable.TotalWeight', dataType: 'number', sort: true },
      { field: 'totalPrice', header: 'ContainerManagement.MainTable.TotalAnt', dataType: 'number', sort: true },
      { field: 'cartonCn', header: 'ContainerManagement.MainTable.TotalCarton', dataType: 'number', sort: true },
      { field: 'cbm', header: 'ContainerManagement.MainTable.TotalDim', dataType: 'number', sort: true },
      { field: 'isReturnTradeVan', header: 'ContainerManagement.MainTable.IsReturnTradeVan', sort: true },
      { field: 'truckRegisterNo', header: 'ContainerManagement.MainTable.TruckRegisterNo', sort: true },
      { field: 'createCarType', header: 'ContainerManagement.MainTable.CreateCarType', sort: true },
      { field: 'licensePlateNo', header: 'ContainerManagement.MainTable.LicensePlateNo', sort: true },
      { field: 'trPaymentBy', header: 'ContainerManagement.MainTable.TrPaymentBy', sort: true }
    ];

    this.detailColumns = this.genDetailTableTranslation();

    this.selectedCols = this.columns;

    this.targetContainer = {
      dos: [],
    };
    this.targetOneContainer = {
      dos: [],
    };
    this.sourceContainer = {
      dos: [],
    };

    this.containerTypeOptions = [];

    this.searchForm = this.fb.group({
      facility: this.laasSetting.facility,
      containerNos: null,
      assignStartDate: null,
      assignEndDate: null,
      containerType: null,
      doNos: null,
      bookingNos: null,
      isLock: '0',
      licensePlateNo: null,
      plateNoFlag: false,
      generateCrossBoundryNoType:'',
      crossBoundryNos: null
    });

    this.isLockOptions = [];
    this.generateCrossBoundryNoOptions = [];

    this.translate.onLangChange.subscribe((e: Event) => {
      this.translationLabel();
    });
    this.translationLabel();

    this.orphanContainer = {
      source: {
        carTypeSource: [],
        carTypeOptions: [{
          label: this.transLabel,
          value: ''
        }],
        createCarType: '',
        plateNo: ''
      },
      target: {
        carTypeSource: [],
        carTypeOptions: [{
          label: this.transLabel,
          value: ''
        }],
        createCarType: '',
        plateNo: ''
      }
    };

    this.normalContainer = {
      source: {
        carTypeSource: [],
        carTypeOptions: [{
          label: this.transLabel,
          value: ''
        }],
        createCarType: '',
        plateNo: ''
      },
      target: {
        carTypeSource: [],
        carTypeOptions: [{
          label: this.transLabel,
          value: ''
        }],
        createCarType: '',
        plateNo: ''
      }
    };
  }

  genDetailTableTranslation(): any[] {
    const fields: string[] = ['carTrip', 'bookingNo', 'doNo', 'invoiceNo', 'consigneeKey', 'consigneeCompany', 'orgName', 'shipCorpName', 'letterHeadOrgName', 'doStatus', 'cartonCnt', 'totalGrossWeight', 'totalNetWeight', 'volumeWeight'];
    const dates: string[] = [];
    const fieldSorts: string[] = [];
    const jsons: string[] = [
      'ContainerManagement.SubTable.CarNumber',
      'ContainerManagement.SubTable.BookingNo',
      'ContainerManagement.SubTable.DONumber',
      'ContainerManagement.SubTable.DOInvoiceNumber',
      'ContainerManagement.SubTable.CustomerCode',
      'ContainerManagement.SubTable.CustomerName',
      'ContainerManagement.SubTable.LoadOrderCompany',
      'ContainerManagement.SubTable.ShipOutCompany',
      'ContainerManagement.SubTable.LetterHeadCompany',
      'ContainerManagement.SubTable.DOStatus',
      'ContainerManagement.SubTable.CartonCount',
      'ContainerManagement.SubTable.GrossWeight',
      'ContainerManagement.SubTable.NetWeight',
      'ContainerManagement.SubTable.Volume',
    ];
    return genTableTranslation(this.translateService, fields, dates, fieldSorts, jsons);
  }

  async ngOnInit(): Promise<void> {
    await super.ngOnInit();

    this.dropdownOptionsService.getFacilityOptions().subscribe({
      next: (result) => {
        this.facilityOptions = result.map((x: any) => {
          return {
            label: x.optionDesc,
            value: x.optionCode,
          };
        });
      },
    });
    this.translateService.get('Common.Message.ChooseOption')
      .subscribe({
        next: str => {
          this.containerTypeOptions = [
            {
              label: 'AM',
              value: 'AM',
            },
            {
              label: 'PM',
              value: 'PM',
            },
          ];
          this.isLockOptions = [
            {
              label: 'Yes',
              value: '1'
            }, {
              label: 'No',
              value: '0'
            },{
              label: 'All',
              value: ''
            }
          ];
          this.generateCrossBoundryNoOptions = [
            {
              label: 'Yes',
              value: 'Y'
            }, {
              label: 'No',
              value: 'N'
            },{
              label: 'All',
              value: ''
            }
          ];

        }
      });

    this.containerService.getChangeContainerSetting().subscribe({
      next: (appCsmSettingBean: any) => {
        if (!appCsmSettingBean || !appCsmSettingBean.appCsmSettingDetailList || appCsmSettingBean.appCsmSettingDetailList.length === 0) {
          return;
        }
        for (const appCsmSettingDetail of appCsmSettingBean.appCsmSettingDetailList) {
          if (appCsmSettingDetail?.setupValue) {
            this.changeContainerWarn = true;
          }
        }
      }
    });

    this.dropdownOptionsService.getDOStatusOptions().subscribe({
      next: (options: any[]) => {
        this.doStatusOptions = options.map(x => ({ label: x.optionDesc, value: x.optionCode }));
      }
    });


    this.dropdownOptionsService.getForwarderOptions()
    .subscribe({
      next: (result: any[]) => {
        this.forwarderOptions = result.map(x => {
          return {
            label: x.optionDesc,
            value: x.optionCode.toString()
          }
        })
      }
    });


    this.containerService.getCarType(this.laasSetting.facility).subscribe({
      next: (result) => {
        this.carTypeOptions = [...result].map((x: any) => {
          return {
            label: `${x.carType} - ${x.carCnDesc} (CBM: ${x.limitCbm})`,
            value: x.carType
          };
        });
      },
    });

    this.logisticsCustomerService.getCustomerOptions('1').subscribe({
      next: (result: any[]) => {
        this.customerOptions = deepCopy(result) ?? [];
      },
    });
  }

  /**
   * Search form reset button click event.
   * @param event Button click event.
   */
  resetBtnClick(event: any): void {
    this.assignDate.ngOnInit();
    this.searchForm.reset();
    this.searchForm.controls.assignStartDate.setValue(null);
    this.searchForm.controls.assignEndDate.setValue(null);
    this.searchForm.controls.plateNoFlag.setValue(false);
  }

  searchBtnClick(): void {
    this.setCurrentPage(0);
    // 這方法可以取消編輯狀態
    this.table.saveSuccessEvent();
    this.queryContainer();
    this.selectedRows.length = 0;
  }

  private setCurrentPage(pageIndex: number): void {
    this.table.first = pageIndex * (this.table.rows ?? 5);
  }

  async expandContainer(event: any): Promise<void> {
    console.log('expand: ' + event);
    const rowData = event.rowData;
    const isClosed = event.expanded;

    if (isClosed) {
      return;
    }

    await this.queryDoDetail(rowData);
  }

  async queryDoDetail(container: any): Promise<void> {
    this.loader.show();
    try {
      const dos = await this.containerService.queryDoDetailByContainerSeqNo(
        container.seqNo
      );
      container.dos = dos;
    } catch (err: any) {
      this.toastErrorMessage(err.error);
      console.log('query do detail occue error: ' + err);
    }
    this.loader.hide();
  }

  queryContainer(): void {
    this.containerLoading = true;
    const request = deepCopy(this.searchForm.value);
    request.pageIndex = this.pageInfo.pageIndex;
    request.pageSize = this.pageInfo.pageSize;
    request.sortOrder = this.sortOrder;

    this.containerService.queryContainer(request).subscribe({
      next: (result: any) => {
        this.containerResults = result.content.map((x: any) => {
          x.containerMainNo = `${this.handleContainerMainNo(
            x.carSeqNo
          )}${this.handleContainerMainNo(
            x.containerType
          )}${this.handleContainerMainNo(
            x.containerNo
          )}${this.handleContainerMainNo(
            x.isExport
          )}${this.handleContainerMainNo(x.facility)}`;
          x.createCarType = x.createCarType ?? '';
          return x;
        });
        this.pageInfo.totalRecords = result.totalElements;
        this.table.setPageInfo(this.pageInfo.totalRecords);
      },
      complete: () => {
        this.containerLoading = false;
      },
    });
  }

  handleContainerMainNo(str: string): string {
    const result = isNullOrEmpty(str) ? '' : str;
    return result;
  }

  async moveContainerClick(event: any): Promise<void> {
    this.loader.show();
    this.targetContainer = {};
    this.sourceContainer = {};
    this.targetContainerOriginal = {};
    this.sourceContainerOriginal = {};

    await this.table.selectedRows.forEach(async (container: any, index: number) => {
      console.log("container"+container);
      await this.queryDoDetail(container);
      if (index === 0) {
        this.targetContainer = deepCopy(container);
        this.targetContainerOriginal = deepCopy(container);

        const carTypeOptions = await this.containerService.getCarType(container.facility).toPromise() ?? [];
        this.normalContainer.target.createCarType = container.createCarType ?? '';
        this.normalContainer.target.plateNo = container.licensePlateNo;
        this.normalContainer.target.facility = container.facility;
        this.normalContainer.target.carTypeSource = carTypeOptions ?? [];
        this.normalContainer.target.carTypeOptions = (carTypeOptions ?? []).map(x => {
          return {
            label: `${x.carType} - ${x.carCnDesc} (CBM: ${x.limitCbm})`,
            value: x.carType
          } as LaasOption;
        });

        this.normalContainer.target.carTypeOptions.unshift({
          label: this.transLabel,
          value: ''
        });

      }
      if (index === 1) {
        this.sourceContainer = deepCopy(container);
        this.sourceContainerOriginal = deepCopy(container);

        const carTypeOptions = await this.containerService.getCarType(container.facility).toPromise() ?? [];
        this.normalContainer.source.createCarType = container.createCarType ?? '';
        this.normalContainer.source.plateNo = container.licensePlateNo;
        this.normalContainer.source.facility = container.facility;
        this.normalContainer.source.carTypeSource = carTypeOptions ?? [];
        this.normalContainer.source.carTypeOptions = (carTypeOptions ?? []).map(x => {
          return {
            label: `${x.carType} - ${x.carCnDesc} (CBM: ${x.limitCbm})`,
            value: x.carType
          } as LaasOption;
        });

        this.normalContainer.source.carTypeOptions.unshift({
          label: this.transLabel,
          value: ''
        });

        this.loader.hide();
        this.showMoveContainerDialog = true;
      }
    });
  }

  async moveOneContainerClick(event: any): Promise<void> {
    this.loader.show();

    this.sourceContainer = {};
    this.targetContainerOriginal = {};
    this.sourceContainerOriginal = {};

    await this.queryDoDetail(this.table.selectedRows[0]);
    const oneContainer = await this.containerService.queryContainerOne
      ({
        containerCode: this.table.selectedRows[0].containerCode
      });
    this.targetOneContainer = oneContainer.master;
    this.targetOneContainer.dos = oneContainer.detail;
    this.sourceContainer = deepCopy(this.table.selectedRows[0]);

    this.sourceContainerOriginal = deepCopy(this.table.selectedRows[0]);
    this.targetContainerOriginal = deepCopy(this.targetOneContainer);

    const carTypeOptions = await this.containerService.getCarType(this.table.selectedRows[0].facility).toPromise() ?? [];
    this.orphanContainer.source.createCarType = this.table.selectedRows[0].createCarType ?? '';
    this.orphanContainer.source.plateNo = this.table.selectedRows[0].licensePlateNo;
    this.orphanContainer.source.facility = this.table.selectedRows[0].facility;
    this.orphanContainer.source.carTypeSource = carTypeOptions ?? [];
    this.orphanContainer.source.carTypeOptions = (carTypeOptions ?? []).map(x => {
      return {
        label: `${x.carType} - ${x.carCnDesc} (CBM: ${x.limitCbm})`,
        value: x.carType
      } as LaasOption;
    });

    this.orphanContainer.source.carTypeOptions.unshift({
      label: this.transLabel,
      value: ''
    });

    this.loader.hide();
    this.showOneMoveContainerDialog = true;
  }

  export(event: any): void {

    const checkChangeListTmp = this.table.selectedRows.map((x: any) => {
      return {
        containerCode: x.containerCode,
        facility: x.facility
      };
    });

    this.containerService.containerChangeInfo({
      checkChangeList: checkChangeListTmp
    }).subscribe({
      next: result => {
        if (result.changeFinished) {
          this.exportExcel();
        } else {
          let msg = '以下尚未完成作業: \n';

          result.unfinishedList?.forEach((x: any) => {
            msg += `${x.containerCodeOld} ${x.bookingNo} ${x.doNo} 尚未完成作業 \n`;
          });

          this.confirmationService.confirm({
            message: msg,
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
              this.exportExcel();
            },
            reject: () => {
              // reject action
            }
          });
        }
      }
    });


  }

  private exportExcel(): void{
    const models: any[] = [];
    this.table.selectedRows.forEach((container: any, index: number) => {
      models.push(container.seqNo);
    });

    this.loader.show();
    this.containerService.export({ seqNos: models, language: this.laasSetting.language }).subscribe({
      next: result => {
        console.log('result:', result);
        if (result === null || result.size === 0) {
          this.translateService.get('ContainerManagement.Info.NoFound')
          .subscribe({
            next: msg => {
              this.toastService.info(msg);
            }
          });
          this.loader.hide();
        } else {
          const file = result;
          file.name = '貨櫃管理報表';
          const url = URL.createObjectURL(file);
          const a: any = document.createElement('a');
          a.href = url;
          a.download = file.name;
          a.click();
          URL.revokeObjectURL(url);
          this.loader.hide();
        }
      },
      complete: () => {
        this.loader.hide();
      }
    });
  }

  private normalTransform(transformObj: any): void {
    this.loader.show();
    this.containerService.transform(transformObj).subscribe({
      next: result => {
        this.loader.hide();
        this.translateService.get('ContainerManagement.Success.UpdateSuccess')
          .subscribe({
            next: msg => {
              this.toastService.success(msg, false);
            }
          });
      },
      error: err => {
        this.toastErrorMessage(err.error);
        this.isLoading = false;
        this.loader.hide();
      },
      complete: () => {
        this.isLoading = false;
        this.searchBtnClick();
        this.showMoveContainerDialog = false;
      }
    });
  }

  confirmMoveClick(event: any): void {
    // 防止連點重複觸發 API
    if (this.isLoading) {
      return;
    }
    this.isLoading = true;

    console.log('source: ' + JSON.stringify(this.sourceContainer));
    console.log('target: ' + JSON.stringify(this.targetContainer));

    const transformObj = this.genTransformCheckRequest(this.sourceContainer, this.targetContainer);

    if (transformObj.target.dos.length === 0 || transformObj.source.dos.length === 0) {
      if (this.changeContainerWarn) {
        this.toastService.error('please try again later');
        this.isLoading = false;
        return;
      }
    }

    transformObj.source.createCarType = this.normalContainer.source.createCarType;
    transformObj.source.plateNo = this.normalContainer.source.plateNo;
    transformObj.source.limitCbm = this.getLimitCbmByCarType(this.normalContainer.source.createCarType, this.normalContainer.source.carTypeSource);

    transformObj.target.createCarType = this.normalContainer.target.createCarType;
    transformObj.target.plateNo = this.normalContainer.target.plateNo;
    transformObj.target.limitCbm = this.getLimitCbmByCarType(this.normalContainer.target.createCarType, this.normalContainer.target.carTypeSource);

    this.containerService.transformCheck('Normal', transformObj).subscribe({
      next: result => {
        if (result.overPrice) {
          this.isLoading = false;
          this.translateService.get('ContainerManagement.Alert.ValueExceeded')
          .subscribe({
            next: msg => {
              this.toastService.warn(msg);
            }
          });
        } else if (result.overLodiing) {
          this.translateService.get('ContainerManagement.Confirm.ChangeContainer')
          .subscribe({
            next: msg => {
              if (result.extraDatas.length > 0) {
                result.extraDatas.forEach((data: any) => {
                  msg += `\n${data.containerCode}: CBM(${data.dynamicCbm}/${data.totalDynamicCbm}) Pallet(${data.pallet}/${data.totalPallet})`;
                });
              }
              this.confirmationService.confirm({
                message: msg,
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                  this.normalTransform(transformObj);
                },
                reject: () => {
                  this.isLoading = false;
                }
              });
            }
          });

        } else {
          this.normalTransform(transformObj);
        }
        this.showMoveContainerDialog = false;
      },
      error: err => {
        this.toastErrorMessage(err.error);
        this.isLoading = false;
      }
    });
  }

  private orphanTransferm(transformObj: any): void {
    this.loader.show();

    this.containerService.transformOnOne(transformObj).subscribe({
      next: result => {
        this.loader.hide();
        this.translateService.get('ContainerManagement.Success.UpdateSuccess')
          .subscribe({
            next: msg => {
              this.toastService.success(msg, false);
            }
          });
      },
      error: err => {
        this.toastErrorMessage(err.error);
        this.isLoading = false;
        this.loader.hide();
      },
      complete: () => {
        this.isLoading = false;
        this.searchBtnClick();
        this.showOneMoveContainerDialog = false;
      }
    });
  }

  confirmOneMoveClick(event: any): void {
    // 防止連點重複觸發 API
    if (this.isLoading) {
      return;
    }
    this.isLoading = true;
    this.loader.show();
    console.log('source: ' + JSON.stringify(this.sourceContainer));
    console.log('targetOne: ' + JSON.stringify(this.targetOneContainer));

    const transformObj = this.genTransformCheckRequest(this.sourceContainer, this.targetOneContainer);

    transformObj.source.createCarType = this.orphanContainer.source.createCarType;
    transformObj.source.plateNo = this.orphanContainer.source.plateNo;
    const limitCbm = this.getLimitCbmByCarType(this.orphanContainer.source.createCarType, this.orphanContainer.source.carTypeSource);
    transformObj.source.limitCbm = limitCbm;

    this.containerService.transformCheck('Orphan', transformObj).subscribe({
      next: result => {
        if (result.overPrice) {
          this.isLoading = false;
          this.loader.hide();
          this.translateService.get('ContainerManagement.Alert.ValueExceeded')
          .subscribe({
            next: msg => {
              this.toastService.warn(msg);
            }
          });
        } else if (result.overLodiing) {
          this.loader.hide();
          this.translateService.get('ContainerManagement.Confirm.ChangeContainer')
          .subscribe({
            next: msg => {
              if (result.extraDatas.length > 0) {
                result.extraDatas.forEach((data: any) => {
                  msg += `\n${data.containerCode}: CBM(${data.dynamicCbm}/${data.totalDynamicCbm}) Pallet(${data.pallet}/${data.totalPallet})`;
                });
              }
              this.confirmationService.confirm({
                message: msg,
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                  this.orphanTransferm(transformObj);
                },
                reject: () => {
                  this.isLoading = false;
                }
              });
            }
          });

        } else {
          this.orphanTransferm(transformObj);
        }
      },
      error: err => {
        this.toastErrorMessage(err.error);
        this.isLoading = false;
        this.loader.hide();
      }
    });
  }

  genTransformCheckRequest(sourceContainer: any, targetContainer: any): any {
    return {
      source: this.genContainerRequestByCompareOriginAndFinalContainer(this.sourceContainerOriginal.dos, sourceContainer),
      target: this.genContainerRequestByCompareOriginAndFinalContainer(this.targetContainerOriginal.dos, targetContainer),
      userId: this.userProfile.loginAccount
    };
  }

  genContainerRequestByCompareOriginAndFinalContainer(originalBookingDoNo: any, finalContainer: any): any {
    const finalContainerRequest = deepCopy(finalContainer);
    finalContainerRequest.dos = [];

    const originalSourceBookingDoNo = originalBookingDoNo.map((x: any) => {
      return `${x.bookingNo}｜${x.doNo}`;
    });

    const afterSourceBookingDoNo = finalContainer.dos.map((x: any) => {
      return `${x.bookingNo}｜${x.doNo}`;
    });

    // 原本有後來沒有
    originalBookingDoNo.filter((x: any) => {
      return !afterSourceBookingDoNo.includes(`${x.bookingNo}｜${x.doNo}`);
    }).map((x: any) => {
      x.changeType = 'DELETE';
      return x;
    }).forEach((x: any) => {
      finalContainerRequest.dos.push(x);
    });

    // 原本沒有後來有
    finalContainer.dos.filter((x: any) => {
      return !originalSourceBookingDoNo.includes(`${x.bookingNo}｜${x.doNo}`);
    }).map((x: any) => {
      x.changeType = 'INSERT';
      return x;
    }).forEach((x: any) => {
      finalContainerRequest.dos.push(x);
    });
    return finalContainerRequest;
  }

  getPickListHeader(obj: any): string {

    const cbmTitle = this.translateService.instant('ContainerManagement.MainTable.TotalCbm');
    const carTypeTitle = this.translateService.instant('ContainerManagement.SubTable.DefaultCarType');

    const header = `${this.transContainerNumber}: ${obj.containerCode}\n${this.transTotalCarton}: ${this.decimalPipe.transform(
      this.handleContainerMainNo(obj.cartonCn),
      '1.0',
      'en-US'
    ) ?? ''}\n${this.transTotalWeight}: ${this.decimalPipe.transform(
      this.handleContainerMainNo(obj.grossWeight),
      '1.0',
      'en-US'
    ) ?? ''}\n${this.transTotalValue}: ${this.decimalPipe.transform(
      this.handleContainerMainNo(obj.totalPrice),
      '1.0',
      'en-US'
    ) ?? ''}\n${cbmTitle}: ${this.decimalPipe.transform(
      this.handleContainerMainNo(obj.cbm),
      '1.0',
      'en-US'
    ) ?? ''}\n${carTypeTitle}: ${obj.createCarType}  (CBM: ${obj.limitCbm})`;


    return header;
  }

  translationLabel(): void{
    this.transContainerNumber = this.translateService.instant('EditContainer.ContainerNumber');
    this.transTotalCarton = this.translateService.instant('EditContainer.TotalCarton');
    this.transTotalWeight = this.translateService.instant('EditContainer.TotalWeight');
    this.transTotalValue = this.translateService.instant('EditContainer.TotalValue');
    this.translateService.get('Common.Message.ChooseOption').subscribe((translated: string) => {
      this.transLabel = this.translateService.instant('Common.Message.ChooseOption');
    });
  }

  moveItem(event: any): void {
    const sounrceCartonCnArr = this.sourceContainer.dos.map((x: any) => {
      return x.cartonCnt;
    });
    const sounrceTotalGrossWeightArr = this.sourceContainer.dos.map((x: any) => {
      return x.totalGrossWeight;
    });
    const sounrceTotalPriceArr = this.sourceContainer.dos.map((x: any) => {
      return x.totalPrice;
    });
    const sounrceTotalCbmArr = this.sourceContainer.dos.map((x: any) => {
      return x.cbm;
    });
    const sounrceCartonCn = this.accumulate(sounrceCartonCnArr);
    const sourceTotalGrossWeight = this.accumulate(sounrceTotalGrossWeightArr);
    const sourceTotalPrice = this.accumulate(sounrceTotalPriceArr);
    const sourceTotalCbm = this.accumulate(sounrceTotalCbmArr);
    this.sourceContainer.cartonCn = sounrceCartonCn;
    this.sourceContainer.grossWeight = sourceTotalGrossWeight;
    this.sourceContainer.totalPrice = sourceTotalPrice;
    this.sourceContainer.cbm = sourceTotalCbm;

    const targetCartonCnArr = this.targetContainer.dos.map((x: any) => {
      return x.cartonCnt;
    });
    const targetTotalGrossWeightArr = this.targetContainer.dos.map((x: any) => {
      return x.totalGrossWeight;
    });
    const targetTotalPriceArr = this.targetContainer.dos.map((x: any) => {
      return x.totalPrice;
    });
    const targetTotalCbmArr = this.targetContainer.dos.map((x: any) => {
      return x.cbm;
    });
    const targetCartonCn = this.accumulate(targetCartonCnArr);
    const targetTotalGrossWeight = this.accumulate(targetTotalGrossWeightArr);
    const targetTotalPrice = this.accumulate(targetTotalPriceArr);
    const targetTotalCbm = this.accumulate(targetTotalCbmArr);
    this.targetContainer.cartonCn = targetCartonCn;
    this.targetContainer.grossWeight = targetTotalGrossWeight;
    this.targetContainer.totalPrice = targetTotalPrice;
    this.targetContainer.cbm = targetTotalCbm;
  }



  moveItemOnOne(event: any): void {
    const sounrceCartonCnArr = this.sourceContainer.dos.map((x: any) => {
      return x.cartonCnt;
    });
    const sounrceTotalGrossWeightArr = this.sourceContainer.dos.map((x: any) => {
      return x.totalGrossWeight;
    });
    const sounrceTotalPriceArr = this.sourceContainer.dos.map((x: any) => {
      return x.totalPrice;
    });
    const sounrceTotalCbmArr = this.sourceContainer.dos.map((x: any) => {
      return x.cbm;
    });
    const sounrceCartonCn = this.accumulate(sounrceCartonCnArr);
    const sourceTotalGrossWeight = this.accumulate(sounrceTotalGrossWeightArr);
    const sourceTotalPrice = this.accumulate(sounrceTotalPriceArr);
    const sourceTotalCbm = this.accumulate(sounrceTotalCbmArr);
    this.sourceContainer.cartonCn = sounrceCartonCn;
    this.sourceContainer.grossWeight = sourceTotalGrossWeight;
    this.sourceContainer.totalPrice = sourceTotalPrice;
    this.sourceContainer.cbm = sourceTotalCbm;

    const targetCartonCnArr = this.targetOneContainer.dos.map((x: any) => {
      return x.cartonCnt;
    });
    const targetTotalGrossWeightArr = this.targetOneContainer.dos.map((x: any) => {
      return x.totalGrossWeight;
    });
    const targetTotalPriceArr = this.targetOneContainer.dos.map((x: any) => {
      return x.totalPrice;
    });
    const targetCartonCn = this.accumulate(targetCartonCnArr);
    const targetTotalGrossWeight = this.accumulate(targetTotalGrossWeightArr);
    const targetTotalPrice = this.accumulate(targetTotalPriceArr);
    this.targetOneContainer.cartonCn = targetCartonCn;
    this.targetOneContainer.grossWeight = targetTotalGrossWeight;
    this.targetOneContainer.totalPrice = targetTotalPrice;
  }

  lockStatus(isLock: boolean, event: any): void {
    if (isLock) {
      const containerCodesTmp = this.table.selectedRows.map((x: any) => {
        return x.containerCode;
      });

      this.containerService.checkExpressBill({
        containerCodes: containerCodesTmp
      }).subscribe({
        next: result => {
          if (result.expressBill && result.oneBookingOneContainer) {
            this.lockingStatus(isLock);
          } else {
            let msg = '';
            if (result.bookingNos?.length > 0) {
              const emptyHawb = this.translate.instant('ContainerManagement.Info.EmptyHawb');
              msg += `${emptyHawb} \n`;
              result.bookingNos?.forEach((booking: string) => {
                msg += `${booking}\n`;
              });
            }

            if (result.noOneBookingNos?.length > 0) {
              const multipleBooking = this.translate.instant('ContainerManagement.Info.MultipleBooking');
              msg += `${multipleBooking} \n`;
              result.noOneBookingNos?.forEach((booking: string) => {
                msg += `${booking}\n`;
              });
            }

            this.confirmationService.confirm({
              message: msg,
              icon: 'pi pi-exclamation-triangle',
              accept: () => {
                this.lockingStatus(isLock);
              },
              reject: () => {
                // reject action
              }
            });
          }

        }
      });
    } else {
      this.lockingStatus(isLock);
    }
  }

  chipsAdd(event: any, fromControlName: any): void {
    const value: string = event.value;
    const parsedValues: string[] = value.split('\r\n').filter(x => isNullOrEmpty(x) === false && x !== '\r\n');
    const formControl = this.searchForm.get(fromControlName);
    formControl?.value.splice(formControl?.value.indexOf(value));
    formControl?.setValue(formControl?.value.concat(parsedValues));
  }

  private lockingStatus(isLock: boolean): void {
    const models: any[] = [];
    this.table.selectedRows.forEach((container: any, index: number) => {
      models.push(container.seqNo);
    });
    this.containerService.lock(isLock ? 1 : 0, { seqNos: models, userId: this.userProfile.loginAccount }).subscribe({
      complete: () => {
        this.containerResults.forEach(x => {
          if (models.indexOf(x.seqNo) !== -1) {
            x.isLock = isLock ? 1 : 0;
          }
        });
      },
      error: (err: any) => {
        this.toastErrorMessage(err.error);
      }
    });
  }

  private accumulate(array: number[]): number{
    const reducer = (accumulator: number, currentValue: number) => accumulator + currentValue;
    if (array.length > 0) {
      return Math.round(array.reduce(reducer) * 100) / 100;
    } else {
      return 0;
    }
  }

  // convenience getter for easy access to form fields
  // tslint:disable-next-line: typedef
  get f() {
    return this.searchForm.controls;
  }

  private arrangChips(array: string[]): string[] {
    const tmp = [] as string[];
    array?.forEach((x: string) => {
      x = x.trim().replace(/	/g, '');
      tmp.push(x);
    });
    return tmp;
  }

  displayExportBtn(): boolean {
    return this.table?.selectedRows?.length > 0;
  }

  displayEditContainerBtn(): boolean {
    const containers = this.table?.selectedRows;

    if (containers && containers.length === 2 && containers[0].isLock === 0 && containers[1].isLock === 0) {

      const container1CarSeqNo = containers[0].carSeqNo;
      const container1ContainerTypeConstraint = containers[0].containerTypeConstraint;
      const container1Facility = containers[0].facility;
      const container1Forwarder = containers[0].forwarder;
      const container1ConsigneeKey = containers[0].consigneeKey;
      const container1PickupLocation = containers[0].pickUpLocation;
      const container1containerTypeMValue = containers[0].containerTypeMValue;


      const container2CarSeqNo = containers[1].carSeqNo;
      const container2ContainerTypeConstraint = containers[1].containerTypeConstraint;
      const container2Facility = containers[1].facility;
      const container2Forwarder = containers[1].forwarder;
      const container2ConsigneeKey = containers[1].consigneeKey;
      const container2PickupLocation = containers[1].pickUpLocation;
      const container2containerTypeMValue = containers[1].containerTypeMValue;

      if (
        (container1CarSeqNo === container2CarSeqNo) &&
        (container1ContainerTypeConstraint === container2ContainerTypeConstraint) &&
        (container1Facility === container2Facility) &&
        (container1Forwarder === container2Forwarder) &&
        (container1containerTypeMValue === container2containerTypeMValue) &&
        (container1PickupLocation === container2PickupLocation)
      ) {
        return true;
      }

      if (
        (container1Facility === 'LK') &&
        (container2Facility === 'LK')
      ) {
        return true;
      }
    }

    return false;
  }

  openOrphanDialog(event: any): void {
    this.showOrphanDialog = true;
  }

  canUnLockContainer(): boolean {
    return this.permissionCodes.includes(this.unlockContainerpermissionCode);
  }

  canLockContainer(): boolean {
    return this.permissionCodes.includes(this.lockContainerpermissionCode);
  }

  facilityPermission(): boolean {
    this.haveFacilityPermission = true;
    this.table.selectedRows.forEach((container: any) => {
      if (container.facility.includes('LK')) {
        this.haveFacilityPermission = false;
      }
    });
    return this.haveFacilityPermission;
  }

  returnData(): void {
    const req: {seqNos: number[]} = {seqNos: []};
    this.haveUnLock = false;
    this.unLockContainerNo = [];
    this.containerLoading = true;

    this.table.selectedRows.forEach((container: any) => {
      if (!container.isLock) {
        this.haveUnLock = true;
        this.unLockContainerNo.push(container.containerCode);
      }
      req.seqNos.push(container.seqNo);
    });

    if (this.haveUnLock) {
      let errMsg = 'Please make sure all container status is locked，unlocked containers：\n';
      this.unLockContainerNo.forEach((containerNo: number) => {
        errMsg = errMsg + containerNo.toString() + '\n';
      });
      this.toastErrorMessage(errMsg);
      this.containerLoading = false;
    }else{
      this.containerService.returnData(req).subscribe({
        next: (result: any) => {
          console.log(result);
        },
        error: (err) => {
            this.toastErrorMessage(err.error());
        },
        complete: () => {
          this.containerLoading = false;
          this.toastService.success(this.translateService.instant('Common.TMS.Success'));
        }
      });
    }

  }

  private getLimitCbmByCarType(carTypeStr: string | null, carTypeSource: CarType[]): number | null {
    if (!carTypeStr) return null;
    const carTypeNames = carTypeStr.split(',')
      .map(s => s.includes(':') ? s.split(':')[0].trim() : s.trim())
      .filter(Boolean);
    const total = carTypeSource
      .filter(x => carTypeNames.includes(x.carType))
      .reduce((sum, x) => sum + (x.limitCbm ?? 0), 0);
    return total > 0 ? total : null;
  }

  dateOnChange(date: any, type: string): void {
    switch (type) {
      case 'AssignDate' :
        this.searchForm.controls.assignStartDate.setValue(date.startDate);
        this.searchForm.controls.assignEndDate.setValue(date.endDate);
        break;
    }
  }

  exportContainerDataDetailExcelClick(event: any): void {
    const selectContainerCodes = this.table.selectedRows.map((container: any) => container.containerCode);
    const request = {
      containerCodes: selectContainerCodes
    };

    this.loader.show();
    this.containerService.exportContainerDataDetailExcel(request).subscribe({
      next: result => {

        if (result === null || result.size === 0) {
          this.translateService.get('Common.Toast.NoData').subscribe({
            next: i18nResult => {
              this.toastService.info(i18nResult);
            }
          });
          this.loader.hide();
        } else {
          const file = result;

          this.translateService.get('ContainerDataDetail_Report').subscribe({
            next: i18nResult => {
              file.name = (new Date().toLocaleDateString() + '_' + i18nResult + '.xlsx');
            }
          });

          const url = URL.createObjectURL(file);
          const a: any = document.createElement('a');
          a.href = url;
          a.download = file.name;
          a.click();
          URL.revokeObjectURL(url);
        }
      },
      complete: () => {
        this.loader.hide();
      }
    });
  }

  displayExportContainerDataDetailExcelBtn(): boolean {
    return this.table?.selectedRows?.length > 0;
  }

  tablePageChange(event: any): void {
    this.pageInfo.pageSize = event.rows;
    this.pageInfo.pageIndex = event.first / this.pageInfo.pageSize;
    this.searchBtnClick();
  }

  tableSort(event: any): void {
    this.sortOrder = { property: event.field, direction: event.order };
    this.searchBtnClick();
  }

  canViewContainerPackingComboBtn(): boolean {
    let visible = true;
    if (!this.permissionCodes.includes(this.viewContainerPackingComboBtnPermissionCode)
        || this.table.selectedRows.some((container: any) => container.isLock === 0 || container.isReturnTradeVan === 'Y')) {
        visible = false;
    }
    return visible;
  }

  canViewDownloadContainerSignReceiptBtn(): boolean {
    let visible = true;
    if (!this.permissionCodes.includes(this.viewDownloadContainerSignReceiptBtnPermissionCode)
        || this.table.selectedRows.some((container: any) => container.isLock === 0)) {
        visible = false;
    }
    return visible;
  }

  canViewSendContainerBoxDetailExcelBtn(): boolean {
    let visible = true;
    if (!this.permissionCodes.includes(this.viewSendContainerBoxDetailExcelBtnPermissionCode)
        || this.table.selectedRows.some((container: any) => container.isLock === 0)) {
        visible = false;
    }
    return visible;
  }
  canViewDownloadUnBondedDocBtn(): boolean {
    return this.permissionCodes.includes(this.ViewDownloadUnBondedDocBtnPermissionCode)
      && !this.table.selectedRows.some((container: any) => container.isLock === 0);
  }

  clickContainerPackingComboBtn(): void {
    this.containerLoading = true;
    if (isNullOrEmpty(this.table.selectedRows)) {
      this.containerLoading = false;
      return;
    }

    if (!isNullOrEmpty(this.table.selectedRows[0].isReturnTradeVan)) {
      this.toastService.error(this.translateService.instant('ContainerManagement.Message.DataHasBeenReturnTradeVan'));
      this.containerLoading = false;
      return;
    }

    this.containerService.triggerContainerPackingCombo(this.table.selectedRows[0].containerCode)
    .subscribe({
      next: (results: any[]) => {
        if (results.length === 0 ||
          results[0].attachFileDetailBeans.length === 0 ||
          isNullOrEmpty(results[0].attachFileDetailBeans[0].file) ||
          isNullOrEmpty(results[0].attachFileDetailBeans[0].fileName)) {
          this.toastService.info(this.translateService.instant('ReceiptFormQuery.Info.NoFileDownload'));
          return;
        }
        const fileInfo = results[0].attachFileDetailBeans[0];
        const byteStr = atob(fileInfo.file);
        const arrayBuffer: ArrayBuffer = new ArrayBuffer(byteStr.length);
        const int8Array: Uint8Array = new Uint8Array(arrayBuffer);
        for (let i = 0; i < byteStr.length; i++) {
          int8Array[i] = byteStr.charCodeAt(i);
        }
        const data: Blob = new Blob(
          [int8Array],
          { type: 'application/octet-stream' }
        );
        const url = URL.createObjectURL(data);
        const linkEle = document.createElement('a');
        linkEle.href = url;
        linkEle.download = fileInfo.fileName;
        linkEle.click();
        URL.revokeObjectURL(url);
        linkEle.remove();
      },
      error: err => {
        this.containerLoading = false;
        this.toastErrorMessage(err.error);
      },
      complete: (): void => {
        this.containerLoading = false;
      }
    });
  }

  clickDownloadContainerSignReceiptBtn(): void {
    this.containerLoading = true;
    if (isNullOrEmpty(this.table.selectedRows)) {
      this.containerLoading = false;
      return;
    }



    this.containerService.downloadContainerSignReceipt(this.table.selectedRows[0].containerCode)
    .subscribe({
      next: (results: any[]) => {
        if (results.length === 0 ||
          results[0].attachFileDetailBeans.length === 0 ||
          isNullOrEmpty(results[0].attachFileDetailBeans[0].file) ||
          isNullOrEmpty(results[0].attachFileDetailBeans[0].fileName)) {
          this.toastService.info(this.translateService.instant('ReceiptFormQuery.Info.NoFileDownload'));
          return;
        }
        const fileInfo = results[0].attachFileDetailBeans[0];
        const byteStr = atob(fileInfo.file);
        const arrayBuffer: ArrayBuffer = new ArrayBuffer(byteStr.length);
        const int8Array: Uint8Array = new Uint8Array(arrayBuffer);
        for (let i = 0; i < byteStr.length; i++) {
          int8Array[i] = byteStr.charCodeAt(i);
        }
        const data: Blob = new Blob(
          [int8Array],
          { type: 'application/octet-stream' }
        );
        const url = URL.createObjectURL(data);
        const linkEle = document.createElement('a');
        linkEle.href = url;
        linkEle.download = fileInfo.fileName;
        linkEle.click();
        URL.revokeObjectURL(url);
        linkEle.remove();
      },
      error: (err: HttpErrorResponse) => {
        this.toastErrorMessage(err);
      },
      complete: (): void => {
        this.containerLoading = false;
      }
    });
  }
  clickDownloadUnBondedDocBtn() {
    this.containerLoading = true;
    if (isNullOrEmpty(this.table.selectedRows)) {
      this.containerLoading = false;
      return;
    }

    this.containerService.downloadUnBondedDoc(this.table.selectedRows[0].containerCode)
    .subscribe({
      next: (results: any[]) => {
        if (results.length === 0 ) {
          this.toastService.info(this.translateService.instant('ReceiptFormQuery.Info.NoFileDownload'));
          return;
        }
        results.forEach(attachFileBean => {
          const isFileInvalid = !attachFileBean.attachFileDetailBeans
            || attachFileBean.attachFileDetailBeans.length === 0
            || isNullOrEmpty(attachFileBean.attachFileDetailBeans[0]?.file)
            || isNullOrEmpty(attachFileBean.attachFileDetailBeans[0]?.fileName);

          if (isFileInvalid) {
            const fileType = attachFileBean.docType === 'ShippingRelease' ? `貨物運出放行單` : `國內貨物進(出)單`;
            this.toastService.info(`${fileType} ` + this.translateService.instant('ReceiptFormQuery.Info.NoFileDownload'));
            return;
          }
          const fileInfo = attachFileBean.attachFileDetailBeans[0];
          const byteStr = atob(fileInfo.file);
          const arrayBuffer: ArrayBuffer = new ArrayBuffer(byteStr.length);
          const int8Array: Uint8Array = new Uint8Array(arrayBuffer);
          for (let i = 0; i < byteStr.length; i++) {
            int8Array[i] = byteStr.charCodeAt(i);
          }
          const data: Blob = new Blob(
            [int8Array],
            { type: 'application/octet-stream' }
          );
          const url = URL.createObjectURL(data);
          const linkEle = document.createElement('a');
          linkEle.href = url;
          linkEle.download = fileInfo.fileName;
          linkEle.click();
          URL.revokeObjectURL(url);
          linkEle.remove();
        })

      },
      error: (err: HttpErrorResponse) => {
        this.toastErrorMessage(err);
      },
      complete: (): void => {
        this.containerLoading = false;
      }
    });

  }

  clickSendContainerBoxDetailExcelBtn(): void {
    this.containerLoading = true;
    if (isNullOrEmpty(this.table.selectedRows)) {
      this.containerLoading = false;
      return;
    }

    this.containerService.sendContainerBoxDetailExcel(this.table.selectedRows[0].containerCode).subscribe({
      next: (result) => {
        this.toastService.success('Send successful');
      },
      error: (err: any) => {
        this.toastErrorMessage(err.error);
      },
      complete: () => {
        this.containerLoading = false;
      }
    });
  }

  createContainerDialog(event: any): void {
    this.showCreateContainerDialog = true;
  }

  containerRowStyle(rowData: any): any {
    if (rowData.cartonCn > rowData.limitBoxQty ) {
      return { 'background-color': 'rgba(254,168,168,1) !important' };
    }
    return {};
  }

  async checkMultipleAddress(savedDataBean: DataTableSavedBean) {
    this.containerLoading = true;
    for (const x of savedDataBean.updatedList) {
      const checkMultipleAddressParams = {
        seqNo: x.seqNo,
        truckRegisterNo: x.truckRegisterNo
      };

      try {
        const result = await firstValueFrom(
          this.containerService.checkMultipleAddress(checkMultipleAddressParams)
        );

        if (result) {
          // 需要顯示確認視窗
          const shouldContinue = await new Promise<boolean>((resolve) => {
            this.confirmationService.confirm({
              header: this.translateService.instant('ContainerManagement.Confirm.Header'),
              message: this.translateService.instant('ContainerManagement.Confirm.MultipleAddress'),
              icon: 'pi pi-info-circle',
              accept: () => resolve(true),   // 按下確認
              reject: () => resolve(false)   // 按下取消
            });
          });

          // 如果使用者按取消，直接停止處理並刷新畫面
          if (!shouldContinue) {
            this.zone.run(() => {
              this.containerLoading = false;
              this.cdr.detectChanges(); // 確保在 Angular zone 內強制刷新
              console.log("使用者取消合併，中斷流程");
              console.log(" complete this.containerLoading = ", this.containerLoading);
            });
            return;
          }
        }

      } catch (err: any) {
        this.toastErrorMessage(err.error);
        this.containerLoading = false;
        this.cdr.detectChanges();
        return;
      }
    }

    // 所有彈窗都按了確認，才會進來這裡儲存
    this.saveData(savedDataBean);
  }
  // async checkMultipleAddress(savedDataBean: DataTableSavedBean) {
  //   savedDataBean.updatedList.forEach((x) => {
  //     var checkMultipleAddressParams = {
  //     seqNo :  x.seqNo,
  //     truckRegisterNo: x.truckRegisterNo
  //     };
  //   // 先去檢查有沒有資料，有要提醒
  //   this.containerService.checkMultipleAddress(checkMultipleAddressParams)
  //   .subscribe({
  //     next: result => {
  //       this.MultipleAddress = result;
  //       console.log("MultipleAddress = ",this.MultipleAddress);

  //       if(this.MultipleAddress) {
  //         this.confirmationService.confirm({
  //           header: this.translateService.instant('ContainerManagement.Confirm.Header'),
  //           message: this.translateService.instant('ContainerManagement.Confirm.MultipleAddress'),
  //           icon: 'pi pi-info-circle',
  //           accept: () => {

  //           },
  //           reject: () => {
  //               return;
  //           }
  //         });
  //       } else {

  //       }
  //     },
  //     error: (err: HttpErrorResponse) => {
  //       this.toastErrorMessage(err.error);
  //     }
  //   });
  //   });
  //   this.saveData(savedDataBean);
  // }

  // checkMultipleAddress(savedDataBean: DataTableSavedBean) {
  //   var checkMultipleAddressParams = {
  //     seqNo :  savedDataBean.updatedList[0].seqNo,
  //     truckRegisterNo: savedDataBean.updatedList[0].truckRegisterNo
  //   };
  //   console.log("checkMultipleAddressParams = ",checkMultipleAddressParams);

	//      // 先去檢查有沒有資料，有要提醒
  //   this.containerService.checkMultipleAddress(checkMultipleAddressParams)
  //   .subscribe({
  //     next: result => {
  //       this.MultipleAddress = result;
  //       console.log("MultipleAddress = ",this.MultipleAddress);

  //       if(this.MultipleAddress) {
  //         this.confirmationService.confirm({
  //           header: this.translateService.instant('ContainerManagement.Confirm.Header'),
  //           message: this.translateService.instant('ContainerManagement.Confirm.MultipleAddress'),
  //           icon: 'pi pi-info-circle',
  //           accept: () => {
  //             this.saveData(savedDataBean);
  //           },
  //           reject: () => {
  //               return;
  //           }
  //         });
  //       } else {
  //         this.saveData(savedDataBean);
  //       }
  //     },
  //     error: (err: HttpErrorResponse) => {
  //       this.toastErrorMessage(err.error);
  //     }
  //   });
  // }


  saveData(savedDataBean: DataTableSavedBean): void {
    const saveDataRequest = {
      updateList: savedDataBean.updatedList.map((x: any) => ({
        ...x,
        createCarType: x.createCarType ?? ''
      })),
      updateUser: this.userProfile.userName
    };
    this.containerLoading = true;
    this.containerService.mergeContainer(saveDataRequest)
      .pipe(finalize(() => {
        this.containerLoading = false;
        console.log(" complete this.containerLoading = ", this.containerLoading);
      }))
      .subscribe({next: result => {
        this.containerLoading = false;
        console.log(" subscribe this.containerLoading = ", this.containerLoading);
        this.table.saveSuccessEvent();
        this.toastService.success(this.translateService.instant('ContainerManagement.Message.MergeSuccess'));
        this.searchBtnClick();

        },
        error: (error: HttpErrorResponse) => {
          if (error.error.errorMsg) {
            this.toastErrorMessage(error.error.errorMsg);
          } else {
            this.toastErrorMessage(error.error);
          }
        },
      });
    }

  dataInputValid(rowData: any): boolean {
    if (rowData) {
      if (isNullOrEmpty(rowData.truckRegisterNo) || isNullOrEmpty(rowData.truckRegisterNo.trim())) {
        this.toastService.warn(this.translateService.instant('ContainerManagement.Message.WrongTRNoFormat'));
        return false;
      }
      // 假設車牌號碼的格式是：以字母開頭，後面跟著數字，並且長度介於 6 到 10 個字符之間
      const truckRegisterNo = rowData.truckRegisterNo.trim();

      // 定義正則表達式，這個例子假設車牌格式是字母開頭跟隨數字，長度範圍 6-10 字符
      const regex = /^\d{2}TR\d{6}\d{4}$/;

      if (!regex.test(truckRegisterNo)) {
        this.toastService.warn(this.translateService.instant('ContainerManagement.Message.WrongTRNoFormat'));
        return false;
      }
      rowData.truckRegisterNo = rowData.truckRegisterNo.trim();

      if (!isNullOrEmpty(rowData.licensePlateNo) && !isNullOrEmpty(rowData.licensePlateNo.trim())) {
        rowData.licensePlateNo = rowData.licensePlateNo.trim();
      }
    }
    return true;
  }

  async sendTruckRegisterRequest(rowData: any): Promise<void> {
    console.log(rowData);
    if (rowData.facility) {
      await this.getTruckRegisterSeq(rowData);
    }
  }


  async getTruckRegisterSeq(rowData: any): Promise<void> {

    const truckRegisterSeq = await this.containerService.getTruckRegisterSeq(rowData.facility).subscribe({
      next: (results: string) => {
        console.log("rowData.facility"+rowData.facility);
        console.log("truckRegisterSeq"+truckRegisterSeq);
        rowData.truckRegisterNo = results;
      },
      error: (err) => {
        this.toastErrorMessage(err.error);
      },
      complete:()=>{
      }
    });

  }



}
